/* eslint-disable no-console */
import { client } from "../../../../Utils/axiosClient";
import { TRIP_STATUS } from "../../../Trips/Data/TripConstants";

export const getTripBatteries = async ({ localTripId, setTripBatteryIds }) => {
  try {
    const response = await client.get(
      `${process.env.REACT_APP_API_URL}/trip/get-trip-batteries`,
      { params: { tripId: localTripId } },
    );

    const tripBatteries = response?.data?.result?.map((item) => ({
      id: item.id,
      value: item.registrationNo,
    }));

    setTripBatteryIds([...tripBatteries]);
  } catch (error) {
    console.log(error);
  }
};

export const getTripIds = async ({ setTripIds }) => {
  try {
    const response = await client.get(
      `${process.env.REACT_APP_API_URL}/trip/get-trip-ids`,
      { params: { statusId: [TRIP_STATUS.ONGOING] } },
    );

    const trips = response?.data?.trips.map((item) => ({
      id: item,
      value: `${item}`,
    }));

    setTripIds([...trips]);
  } catch (error) {
    console.log(error);
  }
};

export const getRentalIds = async ({ setRentalIds }) => {
  try {
    const response = await client.get(
      `${process.env.REACT_APP_API_URL}/rentals/get-batt-request-rental-ids`,
    );

    const rentals = response?.data?.rentals.map((item) => ({
      id: item,
      value: `${item}`,
    }));

    setRentalIds([...rentals]);
  } catch (error) {
    console.log(error);
  }
};
